var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVietcombankSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3967 1.48901C11.5913 2.05315 10.5545 3.3339 10.6612 5.16353C10.7984 7.74027 13.6344 12.6498 14.9913 14.8301C17.3546 18.6571 20.1601 22.1029 23.2705 25.2895C25.7862 27.7748 27.3719 28.3237 30.0706 24.6492C32.3729 21.615 34.4922 18.6114 36.3066 14.8454C37.0995 13.1987 37.8466 11.3995 38.5022 9.3717C39.2036 7.00842 38.9596 4.91958 36.6421 3.39489C38.8681 4.47742 39.8439 6.47477 39.9811 8.68559C40.1184 10.8202 39.478 13.1377 38.9901 14.8454C37.7856 19.0993 36.2304 23.3837 34.2635 27.2412C32.7846 30.1533 30.8939 33.6601 29.0033 36.2521C24.8257 42.0002 20.8309 40.1401 16.1349 36.2521C13.1617 33.7821 10.2953 30.6717 7.84053 27.2564C5.35527 23.8258 2.62606 18.7333 1.00988 14.8149C-1.20093 9.46318 0.521977 6.71873 3.25118 4.98057C6.25484 3.0747 10.7527 1.99216 14.3967 1.48901Z",
    fill: "url(#paint0_linear_4596_4655)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.29 13.7017C18.6354 13.0461 29.9334 12.3447 33.8976 14.403C35.2241 15.0892 35.2546 16.0192 35.1326 17.0713C35.529 16.3547 35.9102 15.6076 36.2914 14.8452C37.0842 13.1985 37.8313 11.3994 38.4869 9.37154C39.1883 7.00826 38.9444 4.91943 36.6268 3.39473C35.773 2.93732 34.7819 2.61713 33.8976 2.35793C31.2904 1.59558 28.3935 1.29065 25.4813 1.07719C24.2768 0.985706 23.0265 1.00095 21.7458 1.00095C19.4435 1.00095 16.9125 1.15342 14.3967 1.48886C11.5913 2.05299 10.5545 3.33374 10.6612 5.16338C10.7832 7.35894 12.8568 11.2469 14.3052 13.7017H14.29Z",
    fill: "url(#paint1_linear_4596_4655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_4655",
    x1: 35.1174,
    y1: 25.9604,
    x2: 3.22069,
    y2: 3.62359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#007A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_4655",
    x1: 15.1133,
    y1: 1.29065,
    x2: 33.9891,
    y2: 14.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#007A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietcombankSquare);
export default __webpack_public_path__ + "static/media/vietcombank-square.72be2818c0373a44df6f96de7218d0f7.svg";
export { ForwardRef as ReactComponent };